import { CustomError } from "./data";
import { fetchWrapper } from "./misc";
// import { msgError } from "./notification";
// import { message } from "antd";

// export const getProfileData = async (setUserData, jwtToken) => {
//   // const [messageApi, contextHolder] = message.useMessage();
//   const res = await fetch(
//     `${process.env.REACT_APP_BASE_URL}/Authentication/ProfileData`,
//     {
//       method: "GET",
//       headers: {
//         Authorization: `Bearer ${jwtToken}`,
//       },
//     }
//   );
//   const profileData = await res.json();
//   if (profileData.resCode === 200) {
//     setUserData(profileData?.resData);
//     return profileData?.resData;
//   } else {
//     // msgError(" User's Team type not found",)
//   }
// };

export const getProfileData = async (setUserData, jwtToken, messageApi,msgError) => {
  try {
    const res = await fetch(
      `${process.env.REACT_APP_BASE_URL}/Authentication/ProfileData`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${jwtToken}`,
        },
      }
    );

    // if (!res.ok) {
    //   msgError(`HTTP Error: ${res.status}`, messageApi);
    //   return;
    // }

    const profileData = await res.json();

    if (profileData.resCode === 200) {
      setUserData(profileData?.resData);
      return profileData?.resData;
    } else {
      msgError(profileData?.resMessage || "User's team type not found", messageApi);
    }
  } catch (error) {
    msgError("Something went wrong while fetching profile data", messageApi);
    console.error("getProfileData Error:", error);
  }
};


export const getPersonContactedData = async (personId, jwtToken) => {
  const res = await fetch(
    `${process.env.REACT_APP_BASE_URL}/Dar/CustDetail?CustId=${personId}`,
    {
      method: "GET",
      headers: {
        Authorization: `Bearer ${jwtToken}`,
      },
    }
  );
  const personResponse = await res.json();
  if (personResponse.resCode === 200) {
    return personResponse?.resData;
  } else {
    console.log("Couldn't fetch contacted person data");
  }
};

export const DeleteDar = async (DarId, jwtToken) => {
  const res = await fetch(
    `${process.env.REACT_APP_BASE_URL}/Dar/DeleteDar?DarId=${DarId}`,
    {
      method: "GET",
      headers: {
        Authorization: `Bearer ${jwtToken}`,
      },
    }
  );
  const personResponse = await res.json();
  if (personResponse.resCode === 200) {
    return personResponse?.resData;
  } else {
    console.log("Couldn't fetch contacted person data");
  }
};

export const getProductLists = async (principalId, jwtToken, action = 'add') => {
  const res = await fetch(
    `${process.env.REACT_APP_BASE_URL}/Dar/ProductListByPrincipalId?PrincipalId=${principalId}&Action=${action}`,
    {
      method: "GET",
      headers: {
        Authorization: `Bearer ${jwtToken}`,
      },
    }
  );
  const Response = await res.json();
  if (Response.resCode === 200) {
    return Response?.resData;
  } else {
    console.log("Couldn't fetch product list data");
  }
};

export const submitDarForm = async (jwtToken, darForm) => {
  const res = await fetch(`${process.env.REACT_APP_BASE_URL}/Dar/DarEntry`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${jwtToken}`,
      "Content-Type": "application/json"
    },
    body: JSON.stringify(darForm),
  });

  const response = await res.json();
  if (response?.resCode === 200) {
    return response?.resData;
  } else {
    console.log("Couldn't post dar form data");
  }
};

export const uploadDarFile = async (jwtToken, DarId, file) => {
console.log(file, 'File')
  let formData = new FormData();
  formData.append('DarId', DarId);
  formData.append('DarDoc', file)

  const res = await fetch(`${process.env.REACT_APP_BASE_URL}/Dar/DarFileUpload`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
    body: formData
  });

  const response = await res.json();
  if (response?.resCode === 200) {
    return Response?.resData;
  } else {
    console.log("Couldn't upload file");
  }
}

export const getPrincipalCategories = async () => {
  try {
    const req = await fetch(
      `${localStorage.getItem("BaseUrl")}/Dar/PrincipalList`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${localStorage.getItem("JwtToken")}`,
        },
      }
    );

    if (req.ok) {
      const res = await req.json();
      if (res.resCode === 200) {
        return res.resData;
      } else {
        return []
      }
    } else {
      return []
    }
  } catch (err) {
    console.log(err.message);
  }
}

export const getQuarterList = async(search, pageNumber, pageSize) => {
  let body = {
    Search: search,
    pageNumber,
    pageSize
  }
  try {
    const req = await fetch(
      `${localStorage.getItem("BaseUrl")}/Holidays/QuarterMasterList`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("JwtToken")}`,
        },
        body: JSON.stringify(body)
      }
    );

    if (req.ok) {
      const res = await req.json();
      if (res.resCode === 200) {
        return res.resData;
      } else {
        return [];
      }
    } else {
      return [];
    }
  } catch (err) {
    console.log(err);
    return [];
  }
}

// get employees
export const getEmployees = async () => {
  try {
    const req = await fetch(
      `${localStorage.getItem("BaseUrl")}/Order/EmployeeList`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${localStorage.getItem("JwtToken")}`,
        },
      }
    );

    if (req.ok) {
      const res = await req.json();
      if (res.resCode === 200) {
        return res.resData;
      } else {
        console.log("response error", res);
        return [];
      }
    } else {
      console.log("request error");
      return [];
    }
  } catch (err) {
    console.log(err);
    return [];
  }
};

// get all employees for order approval
export const getAllEmployees = async () => {
  try {
    const req = await fetch(
      `${localStorage.getItem("BaseUrl")}/Order/OrderApproveEmpList`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${localStorage.getItem("JwtToken")}`,
        },
      }
    );

    if (req.ok) {
      const res = await req.json();
      if (res.resCode === 200) {
        return res.resData;
      } else {
        console.log("response error", res);
        return [];
      }
    } else {
      console.log("request error");
      return [];
    }
  } catch (err) {
    console.error(err.message);
    return [];
  }
};

// get status
export const getStatuses = async () => {
  try {
    const req = await fetch(
      `${localStorage.getItem("BaseUrl")}/Order/OrderStatus`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${localStorage.getItem("JwtToken")}`,
        },
      }
    );

    if (req.ok) {
      const res = await req.json();
      if (res.resCode === 200) {
        console.log(res);
        return res.resData;
      } else {
        console.log("response error", res);
        return [];
      }
    } else {
      console.log("request error");
      return [];
    }
  } catch (err) {
    console.log(err);
    return [];
  }
};

// get customers
export const getCustomers = async(msgError, messageApi) => {
  try {
    const req = await fetch(`${localStorage.getItem("BaseUrl")}/Order/customerList`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("JwtToken")}`
      }
    });

    if(req.ok) {
      const res = await req.json();

      if(res.resCode === 200) {
        return res.resData;
      } else {
        console.log('Response error');
        return [];
      }
    } else {
      msgError('Request Error, Could not fetch customers', messageApi);
      return [];
    }
  } catch(err) {
    msgError('Error Occurred', messageApi);
    return [];
  }
}

// get selected branch accoring to logged in user
export const getSelectedBranch = async (reqBody, userBranch, msgError, messageApi) => {
  try {
    const req = await fetch(
      `${localStorage.getItem("BaseUrl")}/Admin/BranchTargetList`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("JwtToken")}`,
        },
        body: JSON.stringify(reqBody),
      }
    );

    if (req.ok) {
      const res = await req.json();
      if (res.resCode === 200) {
        const data = res.resData.data;
        const branch = data.find((branch) => {
          return branch.branchName === userBranch;
        });
        return branch;
      }
    } else {
      console.log("request error");
      return {}
    }
  } catch (err) {
    msgError('Error Occurred', messageApi);
    return {}
  }
};

// get engineer confirmation
export const getEngineerConfirmationData = async(reqBody) => {
  const userData = JSON.parse(localStorage.getItem("userData"));

  try {
      let reqAddress = `${localStorage.getItem("BaseUrl")}/Order`;

      if(userData.isAppEng) {
        reqAddress = `${reqAddress}/AppEngConfirmation`;
      } else {
        reqAddress = `${reqAddress}/EngineeringConfirmationList`;
      }

      let req = await fetch(reqAddress, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("JwtToken")}`,
        },
        body: JSON.stringify(reqBody),
      })    

      if (req.ok) {
        const res = await req.json();
        if (res.resCode === 200) {
          return {
            data: res.resData.data,
            totalCount: res.resData.totalCount
          }
        } else {
          console.log("response error");
          return {
            data: [],
            totalCount: 0
          }
        }
      } else {
        console.log("request error");
        return {
          data: [],
          totalCount: 0
        }
      }
  } catch(err) {
      console.log(err.message);
      return {
        data: [],
        totalCount: 0
      }
  }
}

// get app-engineer list
export const getAppEngineerList = async() => {
  try {
      const req = await fetch(`${localStorage.getItem("BaseUrl")}/DAR/AppEngineer`, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${localStorage.getItem("JwtToken")}`
          }
      });

      if(req.ok) {
          const res = await req.json();
          if(res.resCode === 200) {
              console.log(res.resData);
              return res.resData;
          } else {
              console.log('response error', res);
              return [];
          }
      } else {
          console.log('request error');
          return [];
      }
  } catch(err) {
      console.log(err);
      return [];
  }
}

export const getAdminPrincipalList = async() => {
  try {
      const req = await fetch(`${localStorage.getItem("BaseUrl")}/Admin/PrincipalList`, {
          method: "GET",
          headers: {
              Authorization: `Bearer ${localStorage.getItem("JwtToken")}`
          }
      });

      if(req.ok) {
          const res = await req.json();
          if(res.resCode === 200) {
              return res.resData;
          } else {
              console.log('response error', res);
              return [];
          }
      } else {
          console.log('request error');
          return [];
      }
  } catch(err) {
      console.log(err);
      return [];
  }
}

export const getBranchAndVerticals = async() => {
  try {
      const req = await fetch(`${localStorage.getItem("BaseUrl")}/ISR/BranchAndVertical`, {
          method: "GET",
          headers: {
              Authorization: `Bearer ${localStorage.getItem("JwtToken")}`
          }
      });

      if(req.ok) {
          const res = await req.json();
          if(res.resCode === 200) {
              return res.resData;
          } else {
              console.log('response error', res);
              return {
                branch: [],
                vertical: []
              }
          }
      } else {
          console.log('request error');
          return {
            branch: [],
            vertical: []
          }
      }
  } catch(err) {
      console.log(err);
      return {
        branch: [],
        vertical: []
      }
  }
}

export const getIsrListOfLoggedInUser = async (branchId) => {
  try {
    const req = await fetch(
      `${localStorage.getItem("BaseUrl")}/Order/OPUISRList?BranchId=${branchId}`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${localStorage.getItem("JwtToken")}`,
        },
      }
    );

    if (req.ok) {
      const res = await req.json();
      if (res.resCode === 200) {
        return res.resData;
      } else {
        console.log("response error");
        return [];
      }
    } else {
      console.log("request error");
      return [];
    }
  } catch (err) {
    console.log(err.message);
    return [];
  }
};

// this function is being used to get the static data on the top section in 
// order generate form, order processed form, order approval edit form,
// engineer confirmation edit form, etc.
export const getOrderEditPageData = async(darId, quotRefNo) => {
  try {
      const req = await fetch(`${localStorage.getItem("BaseUrl")}/Order/ViewOrderGenerate?DarId=${darId}&QuotNo=${quotRefNo}`, {
          method: "GET",
          headers: {
              Authorization: `Bearer ${localStorage.getItem("JwtToken")}`
          }
      });

      if(req.ok) {
          const res = await req.json();
          if(res.resCode === 200) {
              return res.resData;
          }
      } else {
          console.log('request error');
          return {}
      }
  } catch(err) {
      console.log(err.message);
      return {}
  }
}

export const getOrderApprovedData = async(darId, orderId, quotRefNo) => {
  try {
      const req = await fetch(`${localStorage.getItem("BaseUrl")}/Order/ViewOrderApprove?DarId=${darId}&OrderId=${orderId}&QuotNo=${quotRefNo}`, {
          method: "GET",
          headers: {
              Authorization: `Bearer ${localStorage.getItem("JwtToken")}`
          }
      });

      if(req.ok) {
          const res = await req.json();

          if(res.resCode === 200) {
              console.log(res);
              return res.resData;

          } else {
              console.log('response error');
              return {};
          }
      } else {
          console.log('request error');
          return {};
      }
  } catch(err) {
      console.log(err.message);
      return {};
  }
}

export const getFirstDocumentByOrderId = async(orderId) => {
  try {
      const req = await fetch(`${localStorage.getItem("BaseUrl")}/Order/ViewOrderFile1?OrderId=${orderId}`, {
          method: "GET",
          headers: {
              "Content-Type": "application/pdf"
          }
      });

      let contentDisposition = req.headers.get("Content-Disposition");
      let fileName = contentDisposition.split("filename")[1].slice(1, -2);

      if(req.ok) {
          const res = await req.blob();
          const file = new File([res], fileName, { type: res.type });
          if(file) {
            return file;
          } else {
            return {};
          }
      } else {
          return {};
      }

  } catch(err) {
      console.log(err.message);
      return {};
  }
}

export const getSecondDocumentByOrderId = async(orderId) => {
  try {
      const req = await fetch(`${localStorage.getItem("BaseUrl")}/Order/ViewOrderFile2?OrderId=${orderId}`);
      if(req.ok) {
          const res = await req.blob();
          let contentDisposition = req.headers.get("Content-Disposition");
          let fileName = contentDisposition.split("filename")[1].slice(1, -2);
          const file = new File([res], fileName, { type: res.type });
          if(file) {
            return file;
          } else {
            return {};
          }
      } else {
          return {};
      }

  } catch(err) {
      console.log(err.message);
      return {};
  }
}

export const getAllISRs = async() => {
  try {
    const req = await fetch(
      `${localStorage.getItem("BaseUrl")}/Order/AllISRList`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${localStorage.getItem("JwtToken")}`,
        },
      }
    );

    if (req.ok) {
      const res = await req.json();
      if (res.resCode === 200) {
        console.log(res.resData);
        return res.resData;
      } else {
        console.log("response error");
        return [];
      }
    } else {
      console.log("request error");
      return [];
    }
  } catch (err) {
    console.log(err.message);
    return [];
  }
}

// get only branches
export const getBranches = async ({ search, pageNumber, pageSize }) => {
  let body = {
    Search: search,
    pageNumber,
    pageSize
  };
  try {
    const req = await fetch(
      `${localStorage.getItem("BaseUrl")}/Admin/BranchTargetList`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("JwtToken")}`,
        },
        body: JSON.stringify(body),
      }
    );

    if (req.ok) {
      const res = await req.json();
      if (res.resCode === 200) {
        const data = res.resData.data;
        return data;
      }
    } else {
      console.log("request error");
      return [];
    }
  } catch (err) {
    return [];
  }
};

export const getEmployeesByLoginId = async(selectedStatus = 0) => {
  try {
    const req = await fetch(`${localStorage.getItem("BaseUrl")}/Dar/EmpList?EmpStatus=${selectedStatus}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("JwtToken")}`
      }
    });

    if(req.ok) {
      const res = await req.json();
      if(res.resCode === 200) {
        return res.resData;
      } else {
        console.log('Response error');
        return [];
      }
    } else {
      console.log('Request error');
    }
  } catch(err) {
    console.log(err.message);
    return [];
  }
}

export const getSubOrdinatesByEmployeeId = async(empId,EmpStatus) => {
  try {
    const req = await fetch(`${localStorage.getItem("BaseUrl")}/Dar/EmpList1?LogId=${empId}&EmpStatus=${EmpStatus}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("JwtToken")}`
      }
    });
    
    if(req.ok) {
      const res = await req.json();

      if(res.resCode === 200) {
        return res.resData;
      } else {
        console.log('Response error');
        return [];
      }

    } else {
      console.log('Request error');
      return [];
    }
  } catch(err) {
    console.log(err);
    return [];
  }
}

export const getSubVerticalsByVerticalId = async(verticalId) => {
  try {
    const req = await fetch(`${localStorage.getItem("BaseUrl")}/Dar/SubverticalList?VerticalId=${verticalId}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("JwtToken")}`
      }
    });

    if(req.ok) {
      const res = await req.json();
      if(res.resCode === 200) {
        return res.resData;
      } else {
        console.log('Response error');
        return [];
      }
    } else {
      console.log('Request error');
      return [];
    }
  } catch(err) {
    console.log(err.message);
    return [];
  }
}

export const getActivityReport = async({
  employeeId,
  progressId,
  customerId,
  branchId,
  principalId,
  subOrdinateId,
  verticalId,
  subVerticalId,
  search,
  product,
  pageNumber,
  fromDate,
  empStatus,
  toDate,
  pageSize,
  activityTypeId,
  activityOptionId
}) => {
  let body = {
    Employee: employeeId,
    Progress: progressId,
    Customer: customerId,
    BranchId: branchId,
    Principal: principalId,
    SubOrdinate: subOrdinateId,
    Vertical: verticalId,
    SubVertical: subVerticalId,
    Product: product,
    Search: search,
    FromDate: fromDate,
    ToDate: toDate,
    EmpStatus: empStatus,
    ActivityType: activityTypeId,
    ActivityOption: activityOptionId,
    pageNumber,
    pageSize
  }

  let loading = true;
  try {
    loading = true;
    const req = await fetch(`${localStorage.getItem("BaseUrl")}/Dar/DarActivityList`, {
      method: "POST",
      headers: {
       "Content-Type": "application/json",
       Authorization: `Bearer ${localStorage.getItem("JwtToken")}`
     },
     body: JSON.stringify(body)
   });

   if(req.ok) {
    const res = await req.json();

    if(res.resCode === 200) {
      return {
        data: res.resData.data,
        totalCount: res.resData.totalCount
      }
    } else {
      console.log('Response error');
      return {
        data: [],
        totalCount: 0
      }
    }
   } else {
    console.log('Request Error');
    return {
      data: [],
      totalCount: 0
    }
   }
  } catch(err) {
    console.log(err.message);
    return {
      data: [],
      totalCount: 0
    }
  } finally {
    loading = false;
  }
}

export const getAttendanceList = async({ branchId, pageNumber, pageSize, attendanceType, search, UserRoll }) => {
  try {
    const req = await fetch(`${localStorage.getItem("BaseUrl")}/Attendence/WebAttendList`, {
      method: "POST",
      headers: { 
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + localStorage.getItem("JwtToken")
      },
      body: JSON.stringify({ 
        BranchId: branchId, 
        Search: search,
        Attend: attendanceType,
        pageNumber, 
        pageSize,
        UserRoll
      })
    });

    if(req.ok) {
      const res = await req.json();
      if(res.resCode === 200) {
        return res;
      } else {
        throw new Error("Invalid response");
      }
    } else {
      throw new Error("Request error ", req.status, req.statusText);
    }
  } catch(err) {
    throw new Error(err.message, err.code);
  }
}

export const getEmployeeDarList = async({ search, pageNumber, pageSize }) => {
  try {
    let body = {
      Search: search,
      pageNumber,
      pageSize,
    };
    const res = await fetch(`${localStorage.getItem("BaseUrl")}/Dar/DarList`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("JwtToken")}`,
      },
      body: JSON.stringify(body),
    });
    const darList = await res.json();
    if (darList.resCode === 200) {
      return darList.resData.data // table data
      // setTableParams({
      //   ...tableParams,
      //   pagination: {
      //     ...tableParams.pagination,
      //     total: HrMAnualData.resData.totalcount,
      //   },
      // });
    }
  } catch(err) {
    return []
  }
}

export const makeAttendance = async(body) => {
  try {
    const req = await fetch(`${localStorage.getItem("BaseUrl")}/Attendence/AttendenceEntryWeb`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("JwtToken")}`
      },
      body: JSON.stringify(body)
    });

    if(req.ok) {
      const res = await req.json();

      if(res.resCode === 200) {
        return res;
      } else {
        throw new Error('Response error');
      }
    } else {
      throw new Error("Request error");
    }
  } catch(err) {
    console.log(err.message);
  }
}

// designation list
export const getDesignationList = async() => {
  try {
    const request = await fetchWrapper("GET", `${localStorage.getItem("BaseUrl")}/HrManual/DesignationList`, null, true);
    if(request.resCode === 200) {
      return request;
    } else {
      throw new CustomError({
        code: request.code,
        text: request.text
      });
    }
  } catch(err) {
    return err;
  }
}

// active employees list
export const getAllActiveEmployees = async() => {
  try {
    const req = await fetchWrapper("GET", `${localStorage.getItem("BaseUrl")}/HrManual/EmpList`, null, true);
    if(req.resCode === 200) {
      return req;
    } else {
      throw new CustomError({
        code: req.code,
        text: req.text
      });
    }
  } catch(err) {
    return err;
  }
}


export const getDAReligibleEmpList = async( branch = 0 ,vertical =0) => {
  try {
    const req = await fetchWrapper("GET", `${localStorage.getItem("BaseUrl")}/Dar/DarEmpListStatus?verticalId=${vertical?? 0}&branchId=${branch ?? 0}`, null, true);
    if(req.resCode === 200) {
      return req;
    } else {
      throw new CustomError({
        code: req.code,
        text: req.text
      });
    }
  } catch(err) {
    return err;
  }
}